// ---------------------------------------------
// auto-generated from materia/course-project.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MNotAdvice, MChart } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";
import { CourseShell } from "./course.jsx";

// ─────────────────────────────────────────────────────────
// 1. Course · Project / Brief
// ─────────────────────────────────────────────────────────
export const ScreenMCProjBrief = () => (
  <CourseShell
    label="Course · Project / Brief"
    leftRail={false}
    current={6}
    sourceProps={{ note: "Proyecto final · evaluado por rubric pública · sin nota de rentabilidad" }}
    center={
      <div style={{ flex: 1, padding: "32px 56px", overflow: "auto" }}>
        <MEye>Proyecto final · evaluación · ~60 min</MEye>
        <h1 className="m-serif" style={{ fontSize: 48, fontWeight: 600, lineHeight: 1.05, letterSpacing: "-0.03em", margin: "10px 0 12px", fontStyle: "normal" }}>
          Mapa técnico simple de un<br/>activo <em style={{ color: "var(--m-accent)" }}>no visto</em>.
        </h1>
        <div style={{ fontSize: 16, color: "var(--m-text-2)", maxWidth: 720, lineHeight: 1.5, textWrap: "pretty" }}>
          Demuestra lo aprendido sobre un activo que <em>el sistema elige por ti</em> al empezar. Sin pista guiada, con tutor disponible solo para preguntas, no para respuestas.
        </div>

        <div style={{ marginTop: 28, display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 24 }}>
          <div className="m-panel" style={{ padding: 24 }}>
            <MEye>Entrega esperada · 4 partes</MEye>
            <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 16 }}>
              {[
                { n: "01", t: "Identificar tendencia", d: "estructura HH/HL/LH/LL · timeframe declarado", i: "graph" },
                { n: "02", t: "Marcar 2 zonas relevantes",   d: "soporte y resistencia como zonas, no líneas", i: "draw" },
                { n: "03", t: "Comentar contexto en 3 frases", d: "lenguaje no predictivo · sin oportunidad ni urgencia", i: "list" },
                { n: "04", t: "Declarar condición de invalidación", d: "qué evidencia haría que tu lectura sea incorrecta", i: "shield" },
              ].map((s, i) => (
                <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  <div className="mono" style={{
                    width: 40, height: 40, display: "grid", placeItems: "center",
                    borderRadius: 4, background: "var(--m-bg-deep)", border: "1px solid var(--m-line)",
                    color: "var(--m-accent)", fontSize: 12, fontWeight: 600, flexShrink: 0,
                  }}>{s.n}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <Icon name={s.i} size={13} style={{ color: "var(--m-text-2)" }}/>
                      <div style={{ fontSize: 15, fontWeight: 600 }}>{s.t}</div>
                    </div>
                    <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 4, lineHeight: 1.4 }}>{s.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="m-panel" style={{ padding: 24 }}>
            <MEye>Rubric pública</MEye>
            <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { l: "Identificación correcta de tendencia", w: 30, c: "var(--m-positive)" },
                { l: "Zonas razonables (no líneas exactas)", w: 25, c: "var(--m-positive)" },
                { l: "Lenguaje no predictivo", w: 20, c: "var(--m-accent)" },
                { l: "Invalidación declarada", w: 15, c: "var(--m-accent)" },
                { l: "Fuente y timestamp visibles", w: 10, c: "var(--m-text-2)" },
              ].map((r, i) => (
                <div key={i}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: 12.5 }}>{r.l}</span>
                    <span className="mono" style={{ fontSize: 11, color: r.c, fontWeight: 600 }}>{r.w}%</span>
                  </div>
                  <div style={{ height: 4, background: "rgba(216,196,160,0.08)", borderRadius: 2, marginTop: 6 }}>
                    <div style={{ width: `${r.w * 2}%`, height: "100%", background: r.c, opacity: 0.7, borderRadius: 2 }}/>
                  </div>
                </div>
              ))}
            </div>
            <div className="m-divider" style={{ margin: "18px 0" }}/>
            <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>
              umbral · 75% para aprobar · rubric visible durante toda la entrega
            </div>
          </div>
        </div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          <div className="m-misconception" style={{ padding: 20 }}>
            <div className="lbl">Qué NO se evalúa · explícitamente</div>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                "Rentabilidad simulada o real",
                "Decisión correcta de “entrar” o “salir”",
                "Predicción exacta del próximo movimiento",
                "Coincidencia con la opinión del editorial",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 10, fontSize: 12.5, color: "var(--m-text-2)", lineHeight: 1.4 }}>
                  <Icon name="x" size={13} style={{ color: "var(--m-warn)", flexShrink: 0, marginTop: 3 }}/>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="m-panel" style={{ padding: 20, border: "1px solid rgba(155,184,106,0.32)" }}>
            <MEye>Tutor disponible · solo preguntas</MEye>
            <div style={{ marginTop: 12, fontSize: 12.5, color: "var(--m-text-2)", lineHeight: 1.45, textWrap: "pretty" }}>
              El tutor te hará preguntas para ayudarte a pensar. <strong>No te dará la respuesta</strong>. Sus pistas cuentan hacia tu telemetría pero no penalizan.
            </div>
            <div className="m-divider" style={{ margin: "14px 0" }}/>
            <MEye>Auto-revisión guiada al final</MEye>
            <div style={{ marginTop: 8, fontSize: 12, color: "var(--m-text-2)" }}>
              Antes de enviar, repasarás tu trabajo con preguntas socráticas y ajustarás si quieres.
            </div>
          </div>
        </div>

        <div style={{ marginTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <MNotAdvice>Evaluación pedagógica · no constituye certificación financiera</MNotAdvice>
          <div style={{ display: "flex", gap: 10 }}>
            <button className="m-btn"><Icon name="book" size={13}/> Ver ejemplo de proyecto</button>
            <button className="m-btn primary lg"><Icon name="play" size={14}/> Empezar proyecto · 60 min</button>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 2. Course · Project / Workspace
// ─────────────────────────────────────────────────────────
export const ScreenMCProjWorkspace = () => (
  <CourseShell
    label="Course · Project / Workspace · 3-pane"
    current={6}
    sourceProps={{ source: "DEF · activo no visto · 1D", time: "14:32 UTC", note: "PROJECT.WORKSPACE · tools draw + label + textual analysis" }}
    right={
      <div style={{ flex: 1, padding: 16, overflow: "auto", display: "flex", flexDirection: "column", gap: 14 }}>
        <MEye>Tutor · solo preguntas</MEye>
        <div className="m-panel" style={{ padding: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 32, height: 32, borderRadius: 99, background: "rgba(216,168,104,0.16)", display: "grid", placeItems: "center" }}>
              <Icon name="help" size={14} style={{ color: "var(--m-accent)" }}/>
            </div>
            <div>
              <div className="mono" style={{ fontSize: 10, color: "var(--m-accent)", letterSpacing: "0.1em" }}>TUTOR · CARLOS</div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)" }}>modo proyecto · no responde</div>
            </div>
          </div>
          <div style={{ fontSize: 12.5, marginTop: 10, lineHeight: 1.45, padding: 10, background: "var(--m-bg-deep)", borderRadius: 4 }}>
            ¿Tu zona R cubre los 3 toques previos? ¿Qué pasaría si el precio cierra dentro de la zona en la próxima sesión?
          </div>
          <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 4 }}>
            {["¿qué evidencia?","¿cambia tu lectura si...?","¿cómo invalidarías?"].map((c, i) => (
              <span key={i} className="m-chip neutral" style={{ height: 22, fontSize: 9.5 }}>{c}</span>
            ))}
          </div>
        </div>

        <div className="m-divider"/>

        <MEye>Tu progreso en la rubric</MEye>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[
            { l: "Tendencia identificada", w: 30, done: 30, hint: "HH/HL declarados ✓" },
            { l: "Zonas razonables", w: 25, done: 25, hint: "2 zonas + 3 toques cada una ✓" },
            { l: "Lenguaje no predictivo", w: 20, done: 12, hint: "1 frase ambigua detectada" },
            { l: "Invalidación declarada", w: 15, done: 0, hint: "falta" },
            { l: "Fuente y timestamp", w: 10, done: 10, hint: "✓" },
          ].map((r, i) => (
            <div key={i}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 11, color: "var(--m-text)" }}>{r.l}</span>
                <span className="mono" style={{ fontSize: 10, color: r.done === r.w ? "var(--m-positive)" : r.done > 0 ? "var(--m-warn)" : "var(--m-text-3)" }}>
                  {r.done} / {r.w}
                </span>
              </div>
              <div style={{ height: 4, background: "rgba(216,196,160,0.08)", borderRadius: 2, marginTop: 4, overflow: "hidden" }}>
                <div style={{ width: `${(r.done / r.w) * 100}%`, height: "100%", background: r.done === r.w ? "var(--m-positive)" : r.done > 0 ? "var(--m-warn)" : "var(--m-text-3)", opacity: 0.7 }}/>
              </div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 3, letterSpacing: "0.04em" }}>{r.hint}</div>
            </div>
          ))}
        </div>

        <div className="m-divider"/>

        <MEye>Acciones</MEye>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <button className="m-btn ghost sm" style={{ justifyContent: "flex-start" }}>
            <Icon name="save" size={11}/> Guardar borrador
          </button>
          <button className="m-btn accent" style={{ justifyContent: "center" }}>
            <Icon name="check" size={12}/> Pasar a auto-revisión
          </button>
        </div>
      </div>
    }
    center={
      <div style={{ flex: 1, padding: "20px 28px 0", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <MChip variant="copper">PROJECT WORKSPACE</MChip>
          <MChip variant="neutral">DEF · activo no visto · 1D</MChip>
          <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
          <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>tiempo · 12 min · sin límite</span>
        </div>

        <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 10, lineHeight: 1.3, letterSpacing: "-0.01em" }}>
          Produce un mapa técnico prudente. Usa zonas, no líneas. Declara invalidación.
        </h2>

        {/* Toolbar */}
        <div className="m-panel" style={{ marginTop: 12, padding: 5, display: "flex", gap: 4 }}>
          {[
            { i: "draw", l: "Zonas", on: true, n: 2 },
            { i: "tag",  l: "Swings", n: 4 },
            { i: "ind",  l: "Trend line", n: 1 },
            { i: "compare", l: "Multi-TF" },
          ].map((b, i) => (
            <button key={i} style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              height: 30, padding: "0 12px",
              background: b.on ? "rgba(216,168,104,0.16)" : "transparent",
              border: `1px solid ${b.on ? "var(--m-accent)" : "transparent"}`,
              borderRadius: 4, color: b.on ? "var(--m-accent)" : "var(--m-text-2)",
              fontSize: 12, fontWeight: 500, cursor: "pointer",
            }}>
              <Icon name={b.i} size={12}/>
              {b.l}
              {b.n && <span className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)" }}>· {b.n}</span>}
            </button>
          ))}
          <span style={{ flex: 1 }}/>
          <button className="m-btn ghost sm"><Icon name="retry" size={11}/></button>
          <button className="m-btn ghost sm"><Icon name="x" size={11}/></button>
        </div>

        {/* Big chart */}
        <div style={{ marginTop: 10 }}>
          <MChart width={680} height={300} caption="DEF · 1D · 60 sesiones · tu mapa"
            overlays={[
              { type: "zone", topPct: 22, bottomPct: 32, color: "copper", label: "R · 218 — 224" },
              { type: "zone", topPct: 64, bottomPct: 74, color: "default", label: "S · 198 — 204" },
              { type: "swing", xPct: 16, yPct: 76, label: "HL" },
              { type: "swing", xPct: 38, yPct: 58, label: "HL" },
              { type: "swing", xPct: 62, yPct: 38, label: "HH" },
              { type: "swing", xPct: 82, yPct: 28, label: "HH" },
              { type: "trend", from: [12, 80], to: [88, 32], color: "rgba(216,168,104,0.5)" },
            ]}/>
        </div>

        {/* Analysis text + invalidation */}
        <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 14, flex: 1, minHeight: 0 }}>
          <div className="m-panel" style={{ padding: 14, display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <MEye>Análisis · 3 frases</MEye>
              <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>2 / 3 frases</span>
            </div>
            <div className="m-panel-sunk" style={{ marginTop: 8, padding: 12, flex: 1, fontSize: 13, lineHeight: 1.55, color: "var(--m-text)", background: "var(--m-bg-deep)" }}>
              <span>La estructura es de tendencia alcista con tres mínimos crecientes en las últimas 30 sesiones. </span>
              <span>La zona de resistencia entre 218 y 224 ha frenado el precio en tres ocasiones previas con volumen creciente. </span>
              <span style={{ background: "rgba(216,168,104,0.18)", color: "var(--m-warn)" }}>El precio probablemente continúe subiendo,</span>
              <span style={{ color: "var(--m-text-3)" }}> █</span>
            </div>
            <div style={{ marginTop: 6, fontSize: 11, color: "var(--m-warn)", display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="lightbulb" size={11}/> Frase 3 contiene lenguaje predictivo. Considera reformular: "Si rompe con cierre + volumen, …".
            </div>
          </div>

          <div className="m-panel" style={{ padding: 14, display: "flex", flexDirection: "column" }}>
            <MEye>Condición de invalidación</MEye>
            <div className="m-panel-sunk" style={{ marginTop: 8, padding: 12, flex: 1, fontSize: 13, color: "var(--m-text-3)", fontStyle: "italic", background: "var(--m-bg-deep)" }}>
              Escribe qué evidencia haría inválida tu lectura…
            </div>
            <div style={{ marginTop: 6, fontSize: 11, color: "var(--m-negative)", display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="x" size={11}/> Sin invalidación declarada · 15% rubric pendiente
            </div>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 3. Course · Project / Review
// ─────────────────────────────────────────────────────────
export const ScreenMCProjReview = () => (
  <CourseShell
    label="Course · Project / Review"
    leftRail={false}
    current={6}
    sourceProps={{ note: "Auto-revisión guiada · sin tutor · rubric visible · iteración permitida" }}
    center={
      <div style={{ flex: 1, padding: "30px 56px", overflow: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <MChip variant="warn">AUTO-REVISIÓN · paso 3 de 3</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>antes de enviar · puedes iterar</span>
        </div>

        <h1 className="m-serif" style={{ fontSize: 38, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.025em", margin: "12px 0 10px", fontStyle: "normal" }}>
          Mira tu trabajo <em style={{ color: "var(--m-accent)" }}>con otros ojos</em>.
        </h1>
        <div style={{ fontSize: 14, color: "var(--m-text-2)", maxWidth: 740, lineHeight: 1.45 }}>
          Responde con honestidad. Esto no cambia tu calificación: te enseña a ser tu propio editor.
        </div>

        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 24 }}>
          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>Tres preguntas socráticas</MEye>
            <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 18 }}>
              {[
                { q: "¿He usado lenguaje predictivo en alguna frase?", a: "sí · una frase", c: "var(--m-warn)" },
                { q: "¿He declarado fuente, símbolo y timestamp?", a: "sí", c: "var(--m-positive)" },
                { q: "¿Mis zonas explican movimientos previos al menos en 3 toques?", a: "sí · ambas", c: "var(--m-positive)" },
              ].map((p, i) => (
                <div key={i}>
                  <div className="m-serif" style={{ fontSize: 15, lineHeight: 1.4, fontStyle: "normal" }}>{i+1} · {p.q}</div>
                  <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                    {["Sí", "No, todavía no", "No estoy seguro"].map((o, j) => (
                      <span key={j} className="m-chip" style={{
                        height: 28, padding: "0 12px", fontSize: 11,
                        background: (j === 0 && (i === 1 || i === 2)) ? "rgba(155,184,106,0.16)" : (j === 0 && i === 0) ? "rgba(216,168,104,0.16)" : "rgba(216,196,160,0.06)",
                        borderColor: (j === 0 && (i === 1 || i === 2)) ? "rgba(155,184,106,0.4)" : (j === 0 && i === 0) ? "rgba(216,168,104,0.4)" : "var(--m-line)",
                        color: (j === 0 && (i === 1 || i === 2)) ? "var(--m-positive)" : (j === 0 && i === 0) ? "var(--m-warn)" : "var(--m-text-3)",
                      }}>
                        {o}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>Feedback automático · rubric</MEye>
            <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { l: "Tendencia identificada", v: "✓", c: "var(--m-positive)", n: "30 / 30" },
                { l: "Zonas razonables", v: "✓", c: "var(--m-positive)", n: "25 / 25" },
                { l: "Lenguaje no predictivo", v: "◐", c: "var(--m-warn)", n: "12 / 20", note: "1 frase predictiva en frase 3" },
                { l: "Invalidación declarada", v: "✓", c: "var(--m-positive)", n: "15 / 15", note: "añadida tras pista del tutor" },
                { l: "Fuente y timestamp", v: "✓", c: "var(--m-positive)", n: "10 / 10" },
              ].map((r, i) => (
                <div key={i}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ width: 20, color: r.c, fontWeight: 600 }}>{r.v}</span>
                    <span style={{ flex: 1, fontSize: 13 }}>{r.l}</span>
                    <span className="mono" style={{ fontSize: 11, color: r.c }}>{r.n}</span>
                  </div>
                  {r.note && (
                    <div style={{ marginLeft: 30, marginTop: 4, fontSize: 11, color: "var(--m-text-3)", fontStyle: "italic" }}>{r.note}</div>
                  )}
                </div>
              ))}
            </div>
            <div className="m-divider" style={{ margin: "16px 0" }}/>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>SCORE PROVISIONAL</div>
              <div className="mono" style={{ fontSize: 28, color: "var(--m-positive)", fontWeight: 500 }}>92%</div>
            </div>
            <div className="m-meter" style={{ marginTop: 8 }}>
              <div className="fill" style={{ width: "92%" }}/>
              <div className="threshold" style={{ left: "75%" }}/>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 22 }}>
          <div className="m-panel" style={{ padding: 18, display: "flex", alignItems: "center", gap: 14, border: "1px solid rgba(216,168,104,0.3)" }}>
            <Icon name="lightbulb" size={20} style={{ color: "var(--m-warn)" }}/>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13.5, fontWeight: 600 }}>Mejora sugerida · iterar antes de enviar</div>
              <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 4, lineHeight: 1.4 }}>
                Reformula la frase 3 sin lenguaje predictivo. Ej: <em>"Si rompe la zona R con cierre + volumen relativo &gt; 1.5×, …"</em>. Subirá tu rubric a 100%.
              </div>
            </div>
            <button className="m-btn"><Icon name="retry" size={12}/> Iterar frase 3</button>
          </div>
        </div>

        <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <MNotAdvice>Auto-revisión es parte del aprendizaje · no es nota financiera</MNotAdvice>
          <div style={{ display: "flex", gap: 10 }}>
            <button className="m-btn"><Icon name="back" size={13}/> Volver al workspace</button>
            <button className="m-btn accent lg"><Icon name="check" size={14}/> Aceptar entrega · 92%</button>
          </div>
        </div>
      </div>
    }
  />
);
